// extracted by extract-css-chunks-webpack-plugin
module.exports = {"price_oldPrice":"css-2zEtOT7JoT","price_sale":"css-WFR4ilIL4r","price_saleLabel":"css-YWtZFQ9DEF","price__product":"css-3xIF5KooV-"};